import { Flex } from '@rover/kibble/core';
import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';

import type { GalleryImage, PaginationConfig } from './ImageGallery.common';
import ImageGridCloseButton from './ImageGridCloseButton';
import ImageGridContainer from './ImageGridContainer';

type ImageGridProps = {
  images: GalleryImage[] | undefined;
  onClose: () => void;
  onImageClick: (index: number) => void;
  pagination?: PaginationConfig;
};

const ImageGrid = ({ images, onClose, onImageClick, pagination }: ImageGridProps): JSX.Element => {
  return (
    <Flex flexDirection="column" flex="1" width="100%" justifyContent="center" gap="6x">
      {!isReactNative() && <ImageGridCloseButton onClick={onClose} />}
      {images && (
        <ImageGridContainer
          images={images}
          onImageClick={onImageClick}
          onClose={onClose}
          pagination={pagination}
        />
      )}
    </Flex>
  );
};

export default ImageGrid;
